import React from 'react';
import { translate } from 'react-i18next';
import { Dimensions, Image, Platform, StyleSheet, View } from 'react-native';
import placeholderImage from '../../assets/images/body-metric-placeholder.png';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { isWeb } from '../../utils/ScreenSizes';
import { TileHeader } from './TileHeader';

const isWebPlatform = isWeb();
const EmptyBodyMetricGraphTileComponent = ({ t, graphHeading, openSmartScaleEcomm, containerStyle }) => {
  const screenWidth = Dimensions.get('window').width;
  const isSmallScreen = screenWidth < 640;
  const adjustedScreenWidth = isSmallScreen ? screenWidth : screenWidth * 0.33;
  const aspectRatio = 2.2;
  const imageHeight =  adjustedScreenWidth / aspectRatio;
  return (
    <View style={[styles.container, containerStyle]}
    >
      <TileHeader canNavigate={false}>{graphHeading}</TileHeader>
        <View style={openSmartScaleEcomm && styles.graphContainer}>
          {openSmartScaleEcomm &&
            <Button
              fontColor={Theme.PRIMARY}
              buttonType={ButtonTypes.OUTLINE}
              onPress={openSmartScaleEcomm}
              title={t('requiresScale')}
              size={ButtonSize.NORMAL}
            />
          }
          <Image
            source={placeholderImage}
            style={[styles.imageContainer, isWebPlatform && { height: imageHeight, marginTop: defaultScale(0) }]}
            resizeMode={isWebPlatform ? 'contain' : 'cover'}
          />
        </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.WHITE,
    paddingHorizontal: defaultScale(16),
    paddingTop: defaultScale(24),
    paddingBottom: defaultScale(16),
    marginTop: defaultScale(12),
    display: 'flex',
  },
  graphContainer: {
    marginBottom: defaultScale(20),
    marginTop: defaultScale(20),
    display: 'flex',
  },
  imageContainer: {
    height: defaultScale(100),
    width: '100%',
    marginTop: defaultScale(20),
  },
});

export const EmptyBodyMetricGraphTile = translate(['tracking'])(EmptyBodyMetricGraphTileComponent);
